module.exports = __webpack_public_path__ + "static/media/hosting-advice.8d5405dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/hosting-advice.png
// module id = 1819
// module chunks = 146